module.exports = __webpack_public_path__ + "static/media/A18040103_10004_1.bace05c5.jpg";